import {themeDefinition} from "virtual:active-theme-brand"

import {assertThemeDefinitionComplete} from "./assertThemeDefinition"

/**
 * The single client-side entry point for "what brand is this build".
 *
 * Vite aliases `virtual:active-theme-brand` to exactly one file in
 * `themes/brands/` from `VITE_THEME`. The client UMD must not import
 * `themeRegistry`, other brand modules, or the supported-id list — that would
 * ship partner names, palettes, and URLs into another tenant's script.
 *
 * Everything brand-specific — Panda tokens aside, which come from
 * `panda.config.ts` — flows through `activeTheme`: chrome, assets, links,
 * fonts, capabilities. Components should never import a brand id or a
 * per-brand boolean flag; they should read `activeTheme.capabilities.*` or
 * `activeTheme.assets.*` instead.
 */
assertThemeDefinitionComplete(themeDefinition)

export const activeThemeId = themeDefinition.id
export const activeTheme = themeDefinition
